
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IConfirmDialogModel } from './confirm-dialog.model';
import { AcaUiModule } from '@aca/ui';
import { AcaCoreModule } from '@aca/core';
@Component({
    selector: 'confirm-dialog',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <div>
  <div class="mb-4" [innerHTML]="dialogContent().messageBody"></div>

  <div class="grid grid-cols-2 gap-4">
    <div>
      <aca-btn acaColor="danger" [round]="true" (click)="confirm(false)" [disabled]="isClicked">
        {{ dialogContent().cancelText }}
      </aca-btn>
    </div>
    <div>
      <aca-btn acaColor="success" [round]="true" (click)="confirm(true)" [disabled]="isClicked">
        {{ dialogContent().okText }}
      </aca-btn>
    </div>
  </div>
</div>

  `,
    imports: [AcaCoreModule, AcaUiModule]
})
export class ConfirmDialogComponent {

  readonly dialogContent = input.required<IConfirmDialogModel>();

  isClicked = false;

  confirm(confirmation: boolean) {
    this.isClicked = true;

    if (confirmation) {
      this.dialogContent().okFunc()
    }
    else {
      this.dialogContent().cancelFunc()
    }
  }

}
